/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-prototype-builtins */
/* eslint-disable camelcase */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
import { Form, Button, Spin } from 'antd';
import { useMemo, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';
import DokanPageTitle from '../../components/text/DokanPageTitle';
import {
    createWithdraw,
    getAllWithdraw,
    getWithdrawBalance,
    handleWithdrawRequestInput,
    resetWithdrawForm,
    cancelWithdraw,
    resetResponseStatus,
} from '../../redux/withdraw/Actions';

import { getAllPreferences } from '../../redux/preferences/Actions';
import { SHOW_ALERT } from '../../redux/withdraw/Types';
import WithdrawAlert from './withdrawAlert';
import WithdrawTable from './withdrawTable';
import WithdrawCancel from './withdrawCancel';
import WithdrawCreate from './withdrawCreate';
import WithdrawSummaryCard from './withdrawSummaryCard';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

function Withdraw() {
    const [form] = Form.useForm();
    const [checkPending, setCheckPending] = useState(false);
    const [amtvalidationText, setAmtValidationText] = useState('Enter Withdraw Amount');

    const dispatch = useDispatch();
    const { preferences } = useSelector((state) => state.preferences);
    const {
        withdrawList,
        withdrawBalance,
        withdrawStatus,
        lastApproved,
        withdrawRequest,
        responseMessage,
        loader,
        tiny_loader,
        showAlert,
    } = useSelector((state) => state.withdraw);
    const [currentStatus, setCurrentStatus] = useState(withdrawStatus[0].value);
    const [checkLimit, setCheckLimit] = useState(false);

    // modal part

    // cancel withdraw
    const handleCancelWithdraw = () => {
        // eslint-disable-next-line no-use-before-define
        console.log(cancelId);
        // eslint-disable-next-line no-use-before-define
        if (cancelId) {
            // eslint-disable-next-line no-use-before-define
            dispatch(cancelWithdraw(cancelId));
            // eslint-disable-next-line no-use-before-define
            setCancelId(0);
        }

        // eslint-disable-next-line no-use-before-define
        setTimeout(() => setShowCancel(false), 2000);
    };

    // filter by withdraw status....
    // const memoizedStatus = useMemo(() => {}, []);
    const handleWithdrawStatus = (val) => {
        setCurrentStatus(val);
    };

    // last approved withdraw
    const showWithdrawModal = () => {
        console.log('alr');
    };

    // modal functionalities...
    const [visible, setVisible] = useState(false);
    const handleClose = () => {
        dispatch(resetWithdrawForm());
        setVisible(false);
    };

    const openModal = () => {
        console.log(checkPending);
        form.resetFields();
        setVisible(true);
        dispatch({ type: SHOW_ALERT, payload: false });
        dispatch(resetResponseStatus());
    };

    // form handling
    /** ============================ */
    /**    Dynamic Rules */
    /** ============================ */
    const [checkAmount, setCheckAmount] = useState(true);

    const onFinish = (values) => {
        // console.log(withdrawRequest);
        const response = dispatch(createWithdraw(withdrawRequest));
        console.log('response', response);
    };
    const handleChangeInput = (val, name) => {
        dispatch(handleWithdrawRequestInput({ name, value: val }));
        const amountCheck =
            name === 'amount' && val.length > 0 && val >= withdrawBalance.withdraw_limit;
        const methodCheck = name === 'method' && val.length > 0;
        if (amountCheck || methodCheck) {
            setCheckAmount(false);
        } else {
            setCheckAmount(true);
            if (
                withdrawRequest.amount > 0 &&
                withdrawRequest.amount < withdrawBalance.withdraw_limit
            ) {
                setAmtValidationText('Enter minimum withdraw Amount');
            }
        }
    };

    // cancel modal functionalities

    const [showCancel, setShowCancel] = useState(false);
    const [cancelId, setCancelId] = useState(0);
    const handleCancelModal = () => {
        setShowCancel(false);
    };
    const openCancelModal = (id) => {
        setCancelId(id);
        setShowCancel(true);
    };

    const dismissAlert = () => {
        dispatch({ type: SHOW_ALERT, payload: false });
    };

    useEffect(() => {
        setTimeout(() => {
            dispatch({ type: SHOW_ALERT, payload: false });
        }, 5000);
    }, [showAlert, dispatch]);
    useEffect(() => {
        dispatch(getWithdrawBalance());
        if (!Object.keys(preferences).length) {
            dispatch(getAllPreferences());
        }
    }, [dispatch, preferences]);

    useEffect(() => {
        dispatch(getAllWithdraw(currentStatus));
    }, [dispatch, currentStatus]);

    useEffect(() => {
        form.validateFields(['amount']);
    }, [checkAmount]);

    useEffect(() => {
        if (Object.keys(responseMessage).length) {
            if (responseMessage.status >= 200 && responseMessage.status < 300) {
                handleClose();
            }
        }
    }, [responseMessage]);

    const handleTableChange = (pagination) => {
        console.log(pagination);
    };

    return (
        <div className="min-h-screen mx-12 mt-10">
            <div className="flex flex-col md:flex-row justify-start items-start gap-5 md:gap-0 md:justify-between md:items-center">
                <div>
                    <DokanPageTitle>Withdraw</DokanPageTitle>
                </div>
                {/* <div className="text-dark font-extrabold">
                    <button
                        type="button"
                        className="m-2 py-3 px-3 bg-lochmara-blue text-white rounded-md"
                        // onClick={openModal}
                    >
                        <div className="flex gap-2 justify-center items-center">
                            <div>
                                <DokanIcons icon="#gear" />
                            </div>
                            <div>Schedule & Method</div>
                        </div>
                    </button>
                </div> */}
            </div>
            {responseMessage.status >= 200 && responseMessage.status < 300 ? (
                <div className="pt-6">
                    <WithdrawAlert
                        show={showAlert}
                        onClose={dismissAlert}
                        message="Your withdraw request has been submited successfully !"
                    />
                </div>
            ) : null}
            <WithdrawSummaryCard
                preferences={preferences}
                antIcon={antIcon}
                tiny_loader={tiny_loader}
                withdrawBalance={withdrawBalance}
                lastApproved={lastApproved}
                openModal={openModal}
            />
            <WithdrawCreate
                handleClose={handleClose}
                visible={visible}
                showAlert={showAlert}
                responseMessage={responseMessage}
                onFinish={onFinish}
                tiny_loader={tiny_loader}
                form={form}
                checkAmount={checkAmount}
                handleChangeInput={handleChangeInput}
                withdrawRequest={withdrawRequest}
                withdrawBalance={withdrawBalance}
                amtvalidationText={amtvalidationText}
            />
            {/*  */}
            <WithdrawCancel
                handleCancelModal={handleCancelModal}
                showCancel={showCancel}
                setShowCancel={setShowCancel}
                handleCancelWithdraw={handleCancelWithdraw}
                tiny_loader={tiny_loader}
            />

            <WithdrawTable
                withdrawList={withdrawList}
                withdrawStatus={withdrawStatus}
                currentStatus={currentStatus}
                openCancelModal={openCancelModal}
                loader={loader}
                handleWithdrawStatus={handleWithdrawStatus}
            />
        </div>
    );
}

export default Withdraw;
